import React from 'react'
import {Table} from 'react-bootstrap'
import {formatMoney} from '../../helpers/formatMoney'
import {t} from '../../helpers/translate'
import {checkOrg, isAdmin, isMshAdmin} from '../../helpers/access'
import _ from 'lodash';

class PaymentHistoryComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      paymentOption: null,
    }
  }

  renderPayments (card) {
    if (this.props.cancellationStatus !== undefined) {
      let paymentsNew = [];
      {this.props.data.payments.map(
        (payment, index) => {
          if (payment.additional_data.status !== 'pending' ) {
            paymentsNew[index] = payment;
          }
        }
      )}
      this.props.data.payments = paymentsNew;
    }

    return (
      <tbody>
      {this.props.data.payments.map(
        (payment, index) => {
          if (payment.additional_data.hide_dashboard === true) {
            return null;
          }

          let provider = _.capitalize(payment.payment_provider);
          let type = '';

          if(provider === 'Stripe'){
            provider = t('Credit Card');
          }

          if(payment.additional_data.type === 'cancel'){
            type = t('Cancellation');
          } else if(payment.additional_data.type === 'refund'){
            type = t('Refund');
          }

          const data = payment.additional_data;

          return (
            <tr key={index}>
              {this.renderTableCell(index + 1)}
              {this.renderTableCell(`${provider} ${type}`)}
              {this.renderCreditCardDetails(card, payment)}
              {this.renderTableCell((data.type === 'cancel' && payment.total === 0) ? 'N/A' : formatMoney(payment.total, payment.currency))}
              {this.renderTransactionFeeCell(payment)}
              {this.renderPaymentTypeCell(payment)}
              {this.renderTableCell(this.getPaymentStatus(data), `payment-${this.getPaymentClass(data)}`)}
              {this.renderTableCell(payment.payment_date)}
              {this.renderTransactionFeeInputCell(index, payment )}
              {this.renderRefundCell(payment, index)}
              {this.renderTableCell(this.renderSelectPaymentCell(index + 1, payment))}
              {this.renderUserPaymentCell(index + 1, data.user_name_processed_failed_payment, data.payment_type)}
            </tr>
          )
        })}
      </tbody>
    )
  }

  getPaymentClass(data) {
    return data.status || '';
  }

  renderCreditCardDetails (card, payment) {
    return (
      card.length !== 0 ?
        ([
            <td className='payment-history-cardholder-name'>{payment.additional_data.name || 'N/A'}</td>,
            this.renderTableCell(payment.additional_data.brand),
            this.renderTableCell(payment.additional_data.last4),
        ]) : null
    )
  }

  renderTransactionFeeInputCell (index, payment ) {
    if (!this.props.setCancellationFee) {
      return (
        this.props.cancellationStatus !== undefined && payment.additional_data.type === 'charge' ?
          (
            <td><input
              className='transactionFeeInput form-control'
              type='text'
              placeholder='0'
              disabled={this.props.preview}
              onChange={(e) => this.props.onChangeTransactionFee(index, e)}
            /></td>
          ) : <td></td>
      )
    }
  }

  renderTransactionFeeCell (payment) {
    return <td>{((payment.additional_data.type === 'cancel' && payment.total === 0) || !payment.additional_data.transaction_fee) ? 'N/A' : formatMoney(payment.additional_data.transaction_fee, payment.currency)}</td>
  }

  renderRefundCell (payment, index) {
    return payment.additional_data.type === 'charge' && this.props.refunds && this.props.refunds.length>0
    ? this.renderTableCell(formatMoney(this.getRefundableAmountForPayment(this.props.refunds, payment.id, this.props.cancellationFees, index, payment), payment.currency ))
    : this.props.preview ? <td></td> : null;
  }

  renderPaymentTypeCell(payment) {
    const paymentType = _.startCase(payment.additional_data.payment_type.replace('_', ' ').toLowerCase());
    const paidPaymentType = payment.additional_data.paid_payment_type;
    return this.renderTableCell(`${paymentType}${paidPaymentType ? ` - ${paidPaymentType}` : ''}`);
  }

  renderStatusCell(status, index, additional_data) {
    let statusShown = 'Paid';

    if (additional_data['payment_type']) {
      switch(status) {
        case 'succeeded':
          break;
        default:
          statusShown = _.startCase(status.replace('_', ' ').toLowerCase());
      }
    }

    return <td>{statusShown}</td>
  }

  getPaymentStatus(data) {
    return !data['payment_type'] || data['status'] === 'succeeded' ? 'Paid' : _.startCase(data['status'].replace('_', ' ').toLowerCase());
  }

  getPolcyFeeRefundModalBody(payment) {
    return <div className="div-center">
      <p>{`${t('Refund Policy Issue Fee')}: $${payment.total}`}</p>
      <button className="btn button-primary" onClick={this.props.refundPolicyIssueFee.bind(this, payment.id)}>
        {t('Confirm Refund')}
      </button>
    </div>
  }

  getCancellationFeeRefundModalBody(cancellationFee, paymentId){
    return <div className="div-center">
      <p>{t('Refund Cancellation Fee')}: ${cancellationFee}</p>
      <button className="btn button-primary" onClick={this.props.refundCancellationFee.bind(this, paymentId)}>
        {t('Confirm Refund')}
      </button>
    </div>
  }

  getTransactionFeeRefundModalBody(transactionFee, paymentId){
    return <div className="div-center">
      <p>{t('Refund Transaction Fee')}: ${transactionFee}</p>
      <button className="btn button-primary" onClick={this.props.refundTransactionFee.bind(this, paymentId)}>
        {t('Confirm Refund')}
      </button>
    </div>
  }

  selectCheckbox(paymentId) {
    return this.props.paymentsToProcess.includes(paymentId);
  }

  renderSelectPaymentCell(index, payment) {
    if (!this.props.preview && !this.props.cancellationStatus)
    {
      if (this.props.applicationData.status === 'sold'
        && !this.props.editMode
        && ['failed', 'incomplete'].includes(payment.additional_data.status)
        && payment.additional_data.failed_payment_paid !== true
        && !payment.additional_data.void_failed_payment
        && !this.props.applicationData.additional_data.date_cancelled_due_to_failed_payments)
      {
        return <input type="checkbox" value={payment.id} ref="checkbox" checked={this.selectCheckbox(payment.id)} id={`payment${index}`} name="payment" onClick={this.props.addPaymentToBeProcessed.bind(this)}></input>
      } else if (
        isAdmin()
        && payment.additional_data.payment_type === 'Policy Issue Fee'
        && payment.additional_data.status === 'succeeded'
        && !payment.additional_data.refunded)
      {
        return <button className="btn button-secondary" onClick={this.props.showConfirmationModal.bind(this, '', this.getPolcyFeeRefundModalBody(payment), false)}>{t('Process Refund')}</button>
      } else if (
        isMshAdmin()
        && !(checkOrg('ingle') || checkOrg('msg'))
        && !payment.additional_data.refunded
        && payment.additional_data.status === 'succeeded'
        && payment.additional_data.transaction_fee !== undefined
        && payment.additional_data.transaction_fee > 0)
      {
        if (payment.additional_data.payment_type === 'refund') {
          return <button className="btn button-secondary" onClick={this.props.showConfirmationModal.bind(this, '', this.getCancellationFeeRefundModalBody(payment.additional_data.transaction_fee, payment.id), false)}>{t('Process Refund')}</button>
        } else if (payment.additional_data.payment_type === 'Refund') {
          return <button className="btn button-secondary" onClick={this.props.showConfirmationModal.bind(this, '', this.getTransactionFeeRefundModalBody(payment.additional_data.transaction_fee, payment.id), false)}>{t('Process Refund')}</button>
        }
      }
    }
    return <div></div>
  }

  renderUserPaymentCell(index, user_name_processed_failed_payment, payment_type) {
    if (this.props.preview !== true && !this.props.cancellationStatus) {
      if (payment_type == 'Dashboard Payment') {
        return <td>{user_name_processed_failed_payment}</td>
      } else {
        return this.props.preview ? <td></td> : null;
      }
    }
  }

  renderTableCell (value, className = '') {
    return <td className={className}>{value}</td>
  }

  getRefundableAmountForPayment(refunds, paymentId, cancellationFees, index, payment) {
    let paymentToRefund = null;

    if (this.props.setCancellationFee) {
      if (cancellationFees[index] !== undefined && cancellationFees[index] > 0 ) {
        return payment.total
      } else {
        paymentToRefund = refunds.filter((refund) => refund.payment_id == paymentId)[0]
      }
    } else {
      paymentToRefund = refunds.filter((refund) => refund.payment_id == paymentId)[0]
    }

    if (paymentToRefund) {
      return paymentToRefund.refund;
    }
  }

  areDashboardPaymentsShown() {
    var arrayLength = this.props.data.payments.length;

    for (var i = 0; i < arrayLength; i++) {
      if (this.props.data.payments[i].additional_data.payment_type == 'Dashboard Payment') {
        return true;
      }
    }
    return false;
  }

  getPaymentOption() {
    if (this.state.paymentOption !== null) {
      return this.state.paymentOption;
    }

    let applicationData = this.props.applicationData ? this.props.applicationData : [];

    let paymentOption = 'lumpsum';
    if (applicationData.additional_data !== undefined) {
      let additionalData = applicationData.additional_data ? applicationData.additional_data : [];
      paymentOption = additionalData.payment_option ? additionalData.payment_option : 'lumpsum';
    }

    this.setState({paymentOption: paymentOption});
    return paymentOption;
  }

  render() {
    let card = [ t('Cardholder Name'), t('Brand'), `${t('Card Number')}\n${t('Last 4')}`];
    let amount = t('Amount');
    let transaction_fee = t('Transaction\nFee');

    switch (this.props.provider) {
      case 'invoice':
        card = [];
        break;
      default:
        amount = t('Charged ') + amount;
    }

    let paymentOption = this.getPaymentOption();

    const tableHead = ['#', t('Payment Method'), ...card, amount, transaction_fee];

    tableHead.push( t('Type') );

    tableHead.push( t('Status') );
    tableHead.push( t('Date') );

    if (this.props.cancellationStatus && !this.props.setCancellationFee) tableHead.push(t('Transaction\nFee'));

    if (this.props.preview) tableHead.push(t('Refund'));

    if (this.props.preview !== true && !this.props.cancellationStatus && paymentOption == 'monthly' ) {
      if (this.props.applicationData.status == 'sold') {
        tableHead.push(t('Select\nPayment'));
      }

      if (this.areDashboardPaymentsShown() == true ) {
        tableHead.push(t('User'));
      }
    }

    return <Table striped condensed hover id='paymentHistoryTable'>
      <thead>
        <tr>
        {tableHead.map((th, index) => <th key={index}>{th}</th>)}
        </tr>
      </thead>
      {this.renderPayments(card)}
    </Table>
  }
}
PaymentHistoryComponent.displayName = 'PaymentHistoryComponent';
export default PaymentHistoryComponent;



// WEBPACK FOOTER //
// ./src/components/common/PaymentHistoryComponent.js